import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  twitterImage?: string;
  jsonLd?: object | object[];
}

const SEO: React.FC<SEOProps> = ({
  title,
  description,
  keywords,
  ogTitle,
  ogDescription,
  ogImage,
  jsonLd,
}) => {
  const location = useLocation();

  const path = location.pathname.endsWith("/") && location.pathname !== "/" 
  ? location.pathname.slice(0, -1) 
  : location.pathname;

  const currentUrl = `https://wobble.hu${path}`;
  const defaultImage = "https://wobble.hu/assets/mockup_moov_studio.png";

  return (
    <Helmet>
      {/* Alap meta címkék */}
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content="index, follow" />

      {/* Canonical URL */}
      <link rel="canonical" href={currentUrl} />

      {/* Open Graph (Facebook, LinkedIn, stb.) */}
      <meta property="og:title" content={ogTitle || title} />
      <meta property="og:description" content={ogDescription || description} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={ogImage || defaultImage} />

      {/* Mobilbarát nézet */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />

      {/* Strukturált adat (JSON-LD) keresőmotorok és AI asszisztensek számára */}
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
};

export default SEO;
